export default __webpack_public_path__ + "7171dd6dd9af5c23fa643780f0a6e3b9.png";